export const SELECT_DSA_TYPE = 'SELECT_DSA_TYPE';
export const SELECT_LINKED_OPPORTUNITIES = 'SELECT_LINKED_OPPORTUNITIES';
export const CONFIRM_CONVERSION = 'CONFIRM_CONVERSION';
export const CONFIRM_CUSTOMER_CONVERSION = 'CONFIRM_CUSTOMER_CONVERSION';



// WEBPACK FOOTER //
// ./src/constants/createDSAWorkflowSteps.js